import React from 'react';
import Navbar from '../../components/PSTVue/Navbar2';

const PSTDataPrivacy = () => {
  return (
<div>
<Navbar/>
      <div className=" mx-auto p-6 bg-[#04254d] text-white leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">Data Privacy & Compliance</h1>
      <p className="mb-4">
        At PSTVue, we understand the critical responsibility of protecting children's data and ensuring full compliance with national and international regulations governing student privacy. Our platform is designed to empower teachers, students, parents, and administrators while safeguarding sensitive data through state-of-the-art security measures.
      </p>
      <p className="mb-4">
        This document outlines how PSTVue complies with FERPA, COPPA, GDPR, CIPA, and other relevant regulations to ensure that school districts can confidently integrate our platform into their learning environments.
      </p>

      <h2 className="text-2xl font-semibold mb-2">1. Compliance with Key Regulations</h2>

      <h3 className="text-xl font-bold mt-4 mb-1">Family Educational Rights and Privacy Act (FERPA)</h3>
      <p className="mb-2">FERPA protects student education records and gives parents control over their child's data. PSTVue ensures FERPA compliance by:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Limiting access to student data to authorized school officials and educators.</li>
        <li>Providing strict role-based access control (RBAC) to protect personally identifiable information (PII).</li>
        <li>Allowing schools to retain ownership of student records, with no unauthorized third-party sharing.</li>
        <li>Enabling parents and legal guardians to request access or deletion of their child's data.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">Children's Online Privacy Protection Act (COPPA)</h3>
      <p className="mb-2">COPPA regulates the collection of personal information from children under 13. PSTVue fully complies by:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Requiring verifiable parental or school consent before collecting any student data.</li>
        <li>Limiting data collection to only what is necessary for educational purposes, including any voice or audio data captured for speech-based learning features.</li>
        <li>Using transparent privacy policies that clearly outline data usage.</li>
        <li>Ensuring that any third-party integrations do not collect or share children's personal information without compliance.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">General Data Protection Regulation (GDPR)</h3>
      <p className="mb-2">For schools in the European Union, GDPR requires strict data protection controls and user rights. PSTVue ensures GDPR compliance by:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Using strong encryption protocols for storing and transmitting student data.</li>
        <li>Enabling Data Subject Rights (Access, Correction, Deletion, and Portability of student records).</li>
        <li>Ensuring data is only used for educational purposes, with no behavioral tracking or advertising.</li>
        <li>Appointing a Data Protection Officer (DPO) to oversee compliance.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">Children's Internet Protection Act (CIPA)</h3>
      <p className="mb-2">Since CIPA requires schools to filter harmful content on student-accessible platforms, PSTVue integrates the following protections:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Real-time content filtering to ensure educational appropriateness.</li>
        <li>AI-powered moderation to prevent inappropriate content in student-generated discussions.</li>
        <li>Ensuring school IT admins control access to external web content.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">2. Voice, Audio & Microphone Data</h2>
      <p className="mb-4">
        Certain PSTVue features — including the AI Tutor voice chat, Communication Coach, and Voice Quest activities — use the device microphone so students can interact with the platform by speaking. We handle this voice and audio data as follows:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Microphone access is only active while a student is actively using a voice-based feature, never for passive or background listening.</li>
        <li>Speech Recognition: Captured audio is processed using Google Cloud Platform's (GCP) speech-to-text services to power real-time transcription and AI-generated responses, and is never used for advertising, behavioral tracking, or sold to third parties.</li>
        <li>Voice interactions are subject to the same FERPA and COPPA protections described above, including parental/school consent requirements and the right to request deletion.</li>
        <li>Schools and parents can contact us at compliance@mnrtechnologies.com to request details on how long voice/audio data is retained or to request its deletion.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">3. Secure Data Management Practices</h2>

      <h3 className="text-xl font-bold mt-4 mb-1">Data Encryption & Storage</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>End-to-End Encryption: All student data is encrypted in transit (TLS 1.3) and at rest (AES-256).</li>
        <li>Secure Cloud Hosting: We use Azure-based cloud storage, ensuring compliance with FERPA and GDPR.</li>
        <li>Role-Based Access Control (RBAC): Only authorized users (teachers, school admins) can access student data.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">Privacy-First AI</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>No Student Profiling: PSTVue does not track or create behavioral profiles of students.</li>
        <li>AI Transparency: Our AI models operate within strict data minimization principles.</li>
        <li>No Advertising: We do not use student data for targeted ads or marketing.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">Data Access, Retention, and Deletion</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>School Ownership of Data: Schools retain full ownership and control over student records.</li>
        <li>Customizable Retention Policies: Schools can define how long data is stored before automatic deletion.</li>
        <li>Right to Erasure: Parents and administrators can request deletion of student data in compliance with FERPA and GDPR.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">4. Third-Party Vendor Compliance</h2>
      <p className="mb-4">
        PSTVue carefully evaluates and audits any third-party vendors integrated with our platform to ensure they meet:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>FERPA, COPPA, and GDPR compliance requirements.</li>
        <li>Strict data-sharing agreements that prohibit selling or misusing student data.</li>
        <li>Annual security audits to verify compliance.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">5. Audit, Monitoring & Incident Response</h2>

      <h3 className="text-xl font-bold mt-4 mb-1">Regular Security Audits</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>Annual FERPA & COPPA compliance audits.</li>
        <li>Regular penetration testing to identify vulnerabilities.</li>
        <li>Third-party security assessments to ensure best practices.</li>
      </ul>

      <h3 className="text-xl font-bold mt-4 mb-1">Incident Response Plan</h3>
      <p className="mb-2">In the rare event of a data breach, PSTVue follows a strict incident response protocol:</p>
      <ol className="list-decimal ml-6 mb-4">
        <li>Immediate Containment – Isolate and mitigate the impact.</li>
        <li>Investigation & Root Cause Analysis – Determine how the breach occurred.</li>
        <li>Notification Process – Notify schools, authorities, and affected users per legal requirements.</li>
        <li>Remediation & Future Prevention – Strengthen security measures to prevent future risks.</li>
      </ol>

      <h2 className="text-2xl font-semibold mb-2">6. Transparency & Accountability</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Easy-to-read privacy policies for administrators, teachers, and parents.</li>
        <li>Public compliance reports available upon request.</li>
        <li>Dedicated compliance contact for districts to address concerns.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">Conclusion</h2>
      <p className="mb-4">
        PSTVue is fully committed to ensuring compliance with FERPA, COPPA, GDPR, CIPA, and other student data protection laws. By implementing advanced encryption, AI transparency, and strict data governance policies, we provide a safe, compliant, and effective learning platform for schools and districts.
      </p>
      <p className="mb-4">
        We welcome the School District Board to review our compliance documentation and security policies in greater detail.
      </p>

      <h3 className="text-xl font-bold mt-4 mb-1">Contact Us</h3>
      <p className="mb-2">For further inquiries or compliance verification, please contact:</p>
      <p className="mb-2">📧 <a href="mailto:compliance@mnrtechnologies.com" className="text-blue-600 underline">compliance@mnrtechnologies.com</a></p>
      <p className="mb-2">🌐 <a href="https://www.mnrpureai.com/pstvue" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">https://www.mnrpureai.com/pstvue</a></p>

      <p className="mt-6">We look forward to partnering with you to create a safe and secure learning environment for students. 🚀</p>
    </div>
</div>
  );
};

export default PSTDataPrivacy;